<template>
  <DefaultLayout
    :steps-area-title="stepsAreaTitle"
    :steps="steps"
    :features-area-title="featuresAreaTitle"
    :features="features"
  >
    <div class="uploadAreaWrapper">
      <div class="uploadAreaContainer">
        <div class="uploadAreaTitle">{{ pageTitle }}</div>
        <div class="homePageContainer">
          <AsideNav :menus="menus" class="asideNav" />
          <UploadFile
            :accept="accept"
            :limit="limit"
            @onExceed="onUploadExceed"
            @onSuccess="onUploadSuccess"
            v-if="fileList.length === 0"
            class="uploadFileComponent"
            :disabled="isProcessing || isDownloading"
          />
          <div v-else class="fileListComponent">
            <div class="fileListContainer">
              <div class="cardTitleBox">
                <div class="title">文件列表</div>
                <div class="btnGroups">
                  <button class="btn" @click="handleReUpload">重新上传</button>
                  <UploadFileBtn
                    :accept="accept"
                    :limit="limit"
                    @onExceed="onUploadExceed"
                    @onSuccess="onUploadSuccess"
                    :disabled="isDownloading || isProcessing"
                  >
                    <button class="btn">
                      <span class="icon upload_icon"></span>
                      添加图片
                    </button>
                  </UploadFileBtn>
                  <button class="btn download_btn" :disabled="isDownloading || isProcessing" @click="handleDownloadAll">
                    <span class="icon download_icon"></span>
                    全部下载
                  </button>
                  <el-tooltip content="以压缩包形式下载">
                    <img
                      src="@/assets/img/zip.svg"
                      alt=""
                      style="height: 43px; margin-left: 10px; cursor: pointer"
                      @click="handleDownloadZip"
                    />
                  </el-tooltip>
                </div>
              </div>
              <div class="cardList">
                <CompressFileCard
                  :file-info="file"
                  v-for="(file, idx) in fileList"
                  :key="idx"
                  ref="cardRef"
                  :is-loading="file.isLoading"
                  @onPreview="handlePreview(file, idx)"
                  @download="downloadFile(file, idx)"
                  @remove="onRemoveFile(file, idx)"
                  class="cardItem"
                />
              </div>
              <div class="controlContainer">
                <div class="paramsSettingBox">
                  <div class="paramItem">
                    <span class="label">压缩等级：</span>
                    <div class="paramItemValueBox">
                      <el-slider v-model="params.level" class="slider" :min="1" :max="200" />
                      <el-input-number
                        v-model="params.level"
                        :controls="false"
                        :min="1"
                        :max="200"
                        class="inputNumber"
                      />
                      <span class="tips">（数值最大200，数值越大，压缩越小，请不要上传已经压缩过的GIF文件！）</span>
                    </div>
                  </div>
                  <button class="startBtn" @click="handleExecute" :disabled="isProcessing || isDownloading">
                    开始压缩
                  </button>
                </div>
              </div>
              <PreviewModal :dialog-visible="previewVisible" :file-info="previewInfo" @onClose="handleClosePreview" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import UploadFile from '@/components/UploadFile/index.vue'
import AsideNav from '@/components/AsideNav/index.vue'
import { headerMenus } from '../../config/menus.config'
import { COMPRESS_UPLOAD_CONFIG } from '@/config'
import { IMG_COMPRESS_PAGE_CONFIG } from '@/config/page.config'
import { formatTypes } from '../../config'
import { Message } from 'element-ui'
import getImageFileInfo from '../../utils/getImageFileInfo'
import CompressFileCard from '@/components/CompressFileCard/index.vue'
import { compressGif } from '@/core'
import { mixins } from '@/mixin'
import UploadFileBtn from '@/components/UploadFileBtn/index.vue'
import PreviewModal from '@/components/PreviewModal/index.vue'
export default {
  name: 'CompressGif',
  metaInfo() {
    return {
      ...this.tdk
    }
  },
  mixins: [mixins],
  components: {
    CompressFileCard,
    AsideNav,
    UploadFile,
    DefaultLayout,
    UploadFileBtn,
    PreviewModal
  },
  data() {
    return {
      tdk: {},
      accept: '', // 支持的上传格式，例：'.jpg,.webp,...'
      pageTitle: '',
      limit: COMPRESS_UPLOAD_CONFIG.COUNTS, // 最多上传的数量
      menus: [], // 左侧导航栏
      stepsAreaTitle: IMG_COMPRESS_PAGE_CONFIG.STEP_TITLE,
      steps: IMG_COMPRESS_PAGE_CONFIG.STEPS,
      featuresAreaTitle: IMG_COMPRESS_PAGE_CONFIG.FEATURES_TITLE,
      features: IMG_COMPRESS_PAGE_CONFIG.FEATURES,
      fileList: [],
      params: {
        level: 70 // 压缩等级
      },
      previewVisible: false, // 控制预览弹窗
      previewInfo: {}, // 预览图片信息
      isDownloading: false, // 正在下载中
      isProcessing: false, // 正在处理中
      isExecute: false // 是否执行过压缩
    }
  },
  methods: {
    // 点击关闭预览弹窗
    handleClosePreview() {
      this.previewVisible = false
    },
    handlePreview(file, idx) {
      this.previewInfo = file
      this.previewVisible = true
    },
    async downloadFile(file, idx) {
      let flag = await this.$_mixin_checkAllowDownload([file])
      if (flag) {
        let list = await this.$_mixin_download([
          {
            ...file.target,
            filename: `${file.target?.filename}_${new Date().getTime()}`
          }
        ])
        let resList = this.fileList.map(item => {
          list.forEach(it => {
            if (it.fid === item.target?.fid) {
              item.isDownload = it.isDownload
            }
          })
          return item
        })
        this.fileList.splice(0, this.fileList.length, ...resList)
      }
    },
    onRemoveFile(file, idx) {
      this.fileList.splice(idx, 1)
      if (this.fileList.length === 0) {
        this.resetData()
      }
    },
    async handleDownloadAll() {
      if (!this.isExecute) {
        return
      }
      let flag = await this.$_mixin_checkAllowDownload(this.fileList)
      if (flag) {
        let downloadList = this.fileList.map(item => {
          return {
            ...item.target,
            filename: `${item.target?.filename}_${new Date().getTime()}`
          }
        })
        let list = await this.$_mixin_download(downloadList, false)
        let resList = this.fileList.map(item => {
          list.forEach(it => {
            if (it.fid === item.target?.fid) {
              item.isDownload = it.isDownload
            }
          })
          return item
        })

        this.fileList.splice(0, this.fileList.length, ...resList)
      } else {
        this.$_mixin_showPurchaseModal()
      }
    },
    async handleDownloadZip() {
      if (!this.isExecute) {
        return
      }
      let flag = await this.$_mixin_checkAllowDownload(this.fileList)
      if (flag) {
        let downloadList = this.fileList.map(item => {
          return {
            ...item.target,
            filename: `${item.target.filename}_${new Date().getTime()}`
          }
        })
        let list = await this.$_mixin_download(downloadList, true)
        let resList = this.fileList.map(item => {
          list.forEach(it => {
            if (it.fid === item.target?.fid) {
              item.isDownload = it.isDownload
            }
          })
          return item
        })

        this.fileList.splice(0, this.fileList.length, ...resList)
      } else {
        this.$_mixin_showPurchaseModal()
      }
    },
    async init() {
      /* 判断当前路径，渲染左侧导航 */
      if (this.$route.path.indexOf('/gif') != -1) {
        let asideMenus = headerMenus.filter(item => item.key === 'gif')
        if (asideMenus.length !== 0) {
          this.menus = asideMenus[0]?.children
        }
      }
      const { accept, pageTitle, limit, tdk } = this.$route.meta
      this.tdk = {
        title: tdk?.title,
        meta: [
          {
            name: 'keywords',
            content: tdk?.keywords
          },
          {
            name: 'description',
            content: tdk?.description
          }
        ]
      }
      this.accept = accept /* 获取当前支持的上传格式 */
      this.limit = limit
      this.pageTitle = pageTitle
    },
    /**
     * @description 本地上传完成
     * @param file Blob对象
     */
    async onUploadSuccess(file) {
      let supportTypes = []
      let suffixArray = this.accept.split(',')
      suffixArray.forEach(item => {
        let format = item.split('.')[1]
        supportTypes.push(formatTypes[format])
      })
      if (!supportTypes.includes(file.type)) {
        Message({
          type: 'error',
          message: '请上传指定的格式！'
        })
        return
      }
      if (file.size < 100 * 1024 * 1024) {
        if (this.fileList.length === this.limit) {
          this.onUploadExceed()
          return
        }
        // 校验文件大小
        let imgInfo = await getImageFileInfo(file)
        this.fileList.push({
          origin: imgInfo,
          isLoading: false
        })
        if (this.isExecute) {
          // 如果执行过压缩，则后续上传的图片自动压缩
          await this.execute()
        }
      } else {
        this.$Msg({
          showLeft: false,
          rightBtnTxt: '知道了',
          content: `单个文件大小不得超过100MB`
        })
      }
    },
    /**
     * @description 上传文件超出数量限制
     */
    onUploadExceed() {
      this.$Msg({
        showLeft: false,
        rightBtnTxt: '知道了',
        content: `单次上传文件不得超过${this.limit}个`
      })
    },
    /**
     * @description 重新上传
     */
    handleReUpload() {
      if (this.isProcessed) {
        this.$Msg({
          content: '重新上传前先下载保存当前文件，是否重新上传？',
          rightBtnTxt: '重新上传',
          onClickRightBtn: () => {
            this.resetData()
          }
        })
      } else {
        this.resetData()
      }
    },
    resetData() {
      this.params = {
        level: 70
      }
      this.fileList = []
      this.isProcessed = false
      this.isExecute = false
      this.isDownloading = false
      this.previewVisible = false
      this.previewInfo = {}
    },
    /**
     * 点击开始压缩
     */
    handleExecute() {
      this.isExecute = false
      this.execute()
    },
    /**
     * @description 开始压缩
     */
    async execute() {
      this.isProcessed = true

      for (let i = 0; i < this.fileList.length; i++) {
        let file = this.fileList[i]

        if (this.isExecute && file.target) {
          // 如果执行过压缩就没必要重新压缩;
          continue
        }

        file.isLoading = true
        file.isDownload = false
        this.fileList.splice(i, 1, file)

        try {
          let d = await compressGif(file.origin.raw, { level: this.params.level })
          let info = await getImageFileInfo(d)
          file.isLoading = false
          file.target = info
          this.fileList.splice(i, 1, file)
        } catch (e) {
          file.isLoading = false
          this.fileList.splice(i, 1, file)
        }
      }
      this.isProcessing = false
      this.isExecute = true
    }
  },
  async created() {
    await this.init()
  }
}
</script>
<style scoped lang="less">
@import url('./compress.less');
</style>
